import { useEffect } from 'react';
import { useMainContext } from '../context';
import { getAnalyticsEvent } from './getAnalytics';
var useTriggerAnalyticsEvent = function (_a) {
    var featureEvent = _a.featureEvent, questionId = _a.questionId, planOption = _a.planOption, currentRoute = _a.currentRoute, reEnrollAutoPay = _a.reEnrollAutoPay, _b = _a.shouldTrigger, shouldTrigger = _b === void 0 ? true : _b;
    var triggerAnalyticsEvent = useMainContext().triggerAnalyticsEvent;
    useEffect(function () {
        if (!shouldTrigger) {
            return;
        }
        switch (featureEvent || questionId) {
            case 'paymentOptions':
                triggerAnalyticsEvent(getAnalyticsEvent({ featureEvent: 'paymentOptions' }));
                break;
            case 'settlementStart':
                triggerAnalyticsEvent(getAnalyticsEvent({ featureEvent: 'settlementStart', currentRoute: currentRoute }));
                break;
            case 'settlementOptions':
                triggerAnalyticsEvent(getAnalyticsEvent({ featureEvent: 'settlementOptions', currentRoute: currentRoute }));
                break;
            case 'settlementPlanReview':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: 'settlementPlanReview',
                    planOption: planOption,
                    currentRoute: currentRoute
                }));
                break;
            case 'settlementPlanConfirm':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: 'settlementPlanConfirm',
                    planOption: planOption,
                    currentRoute: currentRoute
                }));
                break;
            case 'settlementPlanSuccess':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: 'settlementPlanSuccess',
                    planOption: planOption,
                    currentRoute: currentRoute
                }));
                break;
            case 'settlementOtherPaymentOptions':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: 'settlementOtherPaymentOptions',
                    currentRoute: currentRoute
                }));
                break;
            case 'S001':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: null,
                    questionId: 'S001',
                    currentRoute: currentRoute
                }));
                break;
            case 'S002':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: null,
                    questionId: 'S002',
                    currentRoute: currentRoute
                }));
                break;
            case 'planStart':
                triggerAnalyticsEvent(getAnalyticsEvent({ featureEvent: 'planStart', currentRoute: currentRoute }));
                break;
            case 'planError':
                triggerAnalyticsEvent(getAnalyticsEvent({ featureEvent: 'planError', currentRoute: currentRoute }));
                break;
            case 'planForbearance':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: 'planForbearance',
                    currentRoute: currentRoute
                }));
                break;
            case 'capPlanReview':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: 'capPlanReview',
                    currentRoute: currentRoute
                }));
                break;
            case 'capPlanConfirm':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: 'capPlanConfirm',
                    currentRoute: currentRoute
                }));
                break;
            case 'capOtherPaymentOptions':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: 'capOtherPaymentOptions',
                    currentRoute: currentRoute
                }));
                break;
            case 'capPlanSuccess':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: 'capPlanSuccess',
                    currentRoute: currentRoute,
                    reEnrollAutoPay: reEnrollAutoPay
                }));
                break;
            case 'CAPE001':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: null,
                    questionId: 'CAPE001',
                    currentRoute: currentRoute
                }));
                break;
            case 'CAPE002':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: null,
                    questionId: 'CAPE002',
                    currentRoute: currentRoute
                }));
                break;
            case 'CAPE003':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: null,
                    questionId: 'CAPE003',
                    currentRoute: currentRoute
                }));
                break;
            case 'CAPE004':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: null,
                    questionId: 'CAPE004',
                    currentRoute: currentRoute
                }));
                break;
            case 'CAPE005':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: null,
                    questionId: 'CAPE005',
                    currentRoute: currentRoute
                }));
                break;
            case 'CAPE006':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: null,
                    questionId: 'CAPE006',
                    currentRoute: currentRoute
                }));
                break;
            case 'CAPE007':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: null,
                    questionId: 'CAPE007',
                    currentRoute: currentRoute
                }));
                break;
            case 'CAPE008':
                triggerAnalyticsEvent(getAnalyticsEvent({
                    featureEvent: null,
                    questionId: 'CAPE008',
                    currentRoute: currentRoute
                }));
                break;
            case 'leaving':
                triggerAnalyticsEvent(getAnalyticsEvent({ featureEvent: 'leaving', currentRoute: currentRoute }));
                break;
            default:
                break;
        }
    }, [featureEvent, questionId, planOption, currentRoute, shouldTrigger]);
};
export default useTriggerAnalyticsEvent;
//# sourceMappingURL=triggerAnalyticsEvent.js.map